module.exports = __webpack_public_path__ + "img/jornaypm_adhd_pediatric_band.379cb891.svg";